/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A4Inputs */

const en_pc_faq_a4 = /** @type {(inputs: Pc_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For reading, searching, commenting, filling forms, redacting and organizing, combining or splitting pages, it already does for many people. Reliable editing of existing text, Office conversion, signature-request workflows and non-Latin OCR are not there yet.`)
};

const zh_pc_faq_a4 = /** @type {(inputs: Pc_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在阅读、搜索、批注、填写表单、涂黑以及整理、合并、拆分页面方面，它已经能替代很多人的 Acrobat。稳定编辑已有文字、Office 转换、签名请求流程和非拉丁文字 OCR 暂时还不支持。`)
};

/**
* | output |
* | --- |
* | "For reading, searching, commenting, filling forms, redacting and organizing, combining or splitting pages, it already does for many people. Reliable editing ..." |
*
* @param {Pc_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a4 = /** @type {((inputs?: Pc_Faq_A4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a4(inputs)
	return zh_pc_faq_a4(inputs)
});
export { pc_faq_a4 as "pc.faq.a4" }